import { CmsObjectWithDefault } from '@components/Cms/types';
import { LoginFormCmsWithDefault } from '@components/forms/login/LoginForm/LoginFormCms';
import { EmailLoginFormContainerCmsWithDefault } from '@components/forms/login/EmailLoginForm/EmailLoginFormContainerCms';
import { LoginPanelCmsWithDefault } from '@components/panels/LoginPanel/LoginPanelCms';
import { EmailLoginFormViewCmsWithDefault } from '@components/forms/login/EmailLoginForm/EmailLoginFormViewCms';
import { CmsTranslation } from '@contexts/translation/types';
import { PhoneLoginFormContainerCmsWithDefault } from '@components/forms/login/PhoneLoginForm/PhoneLoginFormContainerCms';
import { PhoneLoginFormViewCmsWithDefault } from '@components/forms/login/PhoneLoginForm/PhoneLoginFormViewCms';
import { CountrySelectCmsWithDefault } from '@components/CountrySelect/CountrySelectCms';
import { ForgotPasswordEmailFormCmsWithDefault } from '@components/forms/forgotPassword/ForgotPasswordEmailForm/ForgotPasswordEmailFormContainerCms';
import { ForgotPasswordEmailPanelCmsWithDefault } from '@components/panels/ForgotPasswordEmailPanel/ForgotPasswordEmailPanelCms';
import { SocialLoginFormCmsWithDefault } from '@components/forms/login/SocialLoginForm/SocialLoginFormCms';
import { PhoneSignupFormContainerCmsWithDefault } from '@components/forms/signup/phoneSignupForm/PhoneSignupFormContainerCms';
import { PhoneSignupFormViewCmsWithDefault } from '@components/forms/signup/phoneSignupForm/PhoneSignupFormViewCms';
import { EmailSignupFormViewCmsWithDefault } from '@components/forms/signup/emailSignupForm/EmailSignupFormViewCms';
import { CaptchaFormInputCms } from '@components/forms/CaptchaFormInput/CaptchaFormInputCms';
import { EmailSignupFormContainerCmsWithDefault } from '@components/forms/signup/emailSignupForm/EmailSignupFormContainerCms';
import { SignupPanelCmsWithDefault } from '@components/panels/SignupPanel/SignupPanelCms';
import { SubmitOtpFormViewCmsWithDefault } from '@components/forms/SubmitOtpForm/SubmitOtpFormViewCms';
import { OtpOptionsFormViewCmsWithDefault } from '@components/forms/OtpOptionsForm/OtpOptionsFormViewCms';
import { TimedLinkCmsWithDefault } from '@components/TimedLink/TimedLinkCms';
import { ChangePasswordPanelCmsWithDefault } from '@components/panels/ChangePasswordPanel/ChangePasswordPanelCms';
import { ChangePasswordViewCmsWithDefault } from '@components/forms/ChangePasswordForm/ChangePasswordFormViewCms';
import { ForgotPasswordPhonePanelCmsWithDefault } from '@components/panels/ForgotPasswordPhonePanel/ForgotPasswordPhonePanelCms';
import { ForgotPasswordPhoneFormCmsWithDefault } from '@components/forms/forgotPassword/ForgotPasswordPhoneForm/ForgotPasswordPhoneFormContainerCms';
import { ChangePasswordContainerCmsWithDefault } from '@components/forms/ChangePasswordForm/ChangePasswordFormContainerCms';
import { SocialLoginButtonsViewCmsWithDefault } from '@components/forms/login/SocialLoginForm/SocialLoginButtonsViewCms';
import { MemberSignoutLinkCmsWithDefault } from '@components/MemberSignoutLink/MemberSignoutLinkCms';
import { ForgotPasswordSocialLoginFormCmsWithDefault } from '@components/forms/forgotPassword/ForgotPasswordSocialLoginForm/ForgotPasswordSocialLoginFormContainerCms';
import { ForgotPasswordPhoneFormViewCmsWithDefault } from '@components/forms/forgotPassword/ForgotPasswordPhoneForm/ForgotPasswordPhoneFormViewCms';
import { ForgotPasswordEmailFormViewCmsWithDefault } from '@components/forms/forgotPassword/ForgotPasswordEmailForm/ForgotPasswordEmailFormViewCms';
import { PhoneAssociationFormCmsWithDefault } from '@components/forms/PhoneAssociationForm/PhoneAssociationFormContainerCms';
import { OtpLoginPanelCmsWithDefault } from '@components/panels/OtpLoginPanel/OtpLoginPanelCms';
import { OtpLoginFormCmsWithDefault } from '@components/forms/login/OtpLoginForm/OtpLoginFormContainerCms';
import { OtpLoginFormViewCmsWithDefault } from '@components/forms/login/OtpLoginForm/OtpLoginFormViewCms';
import { DeleteAccountPanelCmsWithDefault } from '@components/panels/DeleteAccountPanel/DeleteAccountPanelCms';
import { DeleteAccountViewCmsWithDefault } from '@components/panels/DeleteAccountPanel/DeleteAccountViewCms';
import { DeleteAccountResultCmsWithDefault } from '@components/panels/DeleteAccountPanel/DeleteAccountResultCms';
import { MfaPanelCmsWithDefault } from '@components/panels/MfaPanel/MfaPanelCms';
import { LogoCmsWithDefault } from '@components/Logo/LogoCms';
import { AuthedPhoneAssociationFormCmsWithDefault } from '@components/forms/AuthedPhoneAssociation/AuthedPhoneAssociationFormContainerCms';
import { PhoneAssociationPanelCmsWithDefault } from '@components/panels/PhoneAssociationPanel/PhoneAssociationPanelCms';
import { PasswordHelpersCmsWithDefault } from '../../utils/PasswordHelpersCms';
import { MagicLinkFormCmsWithDefault } from '@components/forms/MagicLinkForm/MagicLinkFormCms';
import { SessionPackageCmsWithDefault } from '@components/SessionPackage/SessionPackageCms';
import { EmailLoginFormCmsWithDefault } from '@v2/components/Forms/EmailLoginForm/EmailLoginFormCmsWithDefault';
import { OtpFormCmsWithDefault } from '@v2/components/Forms/OtpForm/OtpFormCmsWithDefault';
import { ProfileFormCmsWithDefault } from '@v2/components/Forms/Profile/ProfileFormCms';
import { OtherWaysToSignInFormCmsWithDefault } from '@v2/components/Forms/OtherWaysToSigninForm/OtherWaysToSigninFormCmsWithDefault';
import { SocialButtonsCmsWithDefault } from '@v2/components/SocialButtons/SocialButtonsCmsWithDefault';
import { DatePickerCmsWithDefault } from '@v2/components/DatePicker/DatePickerCmsWithDefault';
import { ForceLogoutFormCmsWithDefault } from '@v2/components/ForceLogout/ForceLogoutFormCms';
import { PinFormCmsWithDefault } from '@v2/components/Forms/PinForm/PinFormCmsWithDefault';
import { WalletOtpFormCmsWithDefault } from '@v2/components/Forms/WalletOtpForm/WalletOtpFormCmsWithDefault';
import { ResetPinResultCmsWithDefault } from '@v2/pages/resetPin/ResetPinCmsWithDefault';
import { DateOfBirthFormCmsWithDefault } from '@v2/components/Forms/DateOfBirthForm/DateOfBirthFormCmsWithDefault';
import { ScaPanelCmsWithDefault } from '@v2/pages/sca/ScaPanelCmsWithDefault';
import { WalletResultCmsWithDefault } from '@v2/components/Wallet/WalletResultCmsWithDefault';
import { MagicLinkFormCmsWithDefaultV2 } from '@v2/components/Forms/MagicLinkForm/MagicLinkFormCmsWithDefault';
import { TermsAndPolicyCmsWithDefault } from '@components/panels/LoginPanel/TermsAndPolicyCms';
import { WalletAuthCmsWithDefault } from '@v2/pages/walletAuth/WalletAuthCmsWithDefault';
import { WhatsAppFormCmsWithDefault } from '@v2/components/Forms/WhatsAppForm/WhatsAppFormCmsWithDefault';

const allCmsWithDefault = [
    LoginFormCmsWithDefault,
    EmailLoginFormContainerCmsWithDefault,
    EmailLoginFormViewCmsWithDefault,
    LoginPanelCmsWithDefault,
    PhoneLoginFormContainerCmsWithDefault,
    PhoneLoginFormViewCmsWithDefault,
    CountrySelectCmsWithDefault,
    ForgotPasswordEmailPanelCmsWithDefault,
    ForgotPasswordEmailFormCmsWithDefault,
    ForgotPasswordEmailFormViewCmsWithDefault,
    ForgotPasswordPhonePanelCmsWithDefault,
    ForgotPasswordPhoneFormCmsWithDefault,
    ForgotPasswordPhoneFormViewCmsWithDefault,
    SocialLoginFormCmsWithDefault,
    PhoneSignupFormContainerCmsWithDefault,
    PhoneSignupFormViewCmsWithDefault,
    EmailSignupFormViewCmsWithDefault,
    CaptchaFormInputCms,
    EmailSignupFormContainerCmsWithDefault,
    SignupPanelCmsWithDefault,
    SubmitOtpFormViewCmsWithDefault,
    OtpOptionsFormViewCmsWithDefault,
    TimedLinkCmsWithDefault,
    SocialLoginButtonsViewCmsWithDefault,
    ChangePasswordPanelCmsWithDefault,
    ChangePasswordViewCmsWithDefault,
    ChangePasswordContainerCmsWithDefault,
    MemberSignoutLinkCmsWithDefault,
    ForgotPasswordSocialLoginFormCmsWithDefault,
    PhoneAssociationFormCmsWithDefault,
    OtpLoginPanelCmsWithDefault,
    OtpLoginFormCmsWithDefault,
    OtpLoginFormViewCmsWithDefault,
    DeleteAccountPanelCmsWithDefault,
    DeleteAccountViewCmsWithDefault,
    DeleteAccountResultCmsWithDefault,
    MfaPanelCmsWithDefault,
    LogoCmsWithDefault,
    AuthedPhoneAssociationFormCmsWithDefault,
    PhoneAssociationPanelCmsWithDefault,
    PasswordHelpersCmsWithDefault,
    MagicLinkFormCmsWithDefault,
    SessionPackageCmsWithDefault,
    EmailLoginFormCmsWithDefault,
    OtpFormCmsWithDefault,
    ProfileFormCmsWithDefault,
    OtherWaysToSignInFormCmsWithDefault,
    SocialButtonsCmsWithDefault,
    ForceLogoutFormCmsWithDefault,
    DatePickerCmsWithDefault,
    PinFormCmsWithDefault,
    WalletOtpFormCmsWithDefault,
    ResetPinResultCmsWithDefault,
    DateOfBirthFormCmsWithDefault,
    ScaPanelCmsWithDefault,
    WalletResultCmsWithDefault,
    MagicLinkFormCmsWithDefaultV2,
    TermsAndPolicyCmsWithDefault,
    WalletAuthCmsWithDefault,
    WhatsAppFormCmsWithDefault,
];

const getCmsIds = (cmsWithDefault: CmsObjectWithDefault) =>
    Object.entries(cmsWithDefault).map(([, value]) => value.cmsId);

export const allCmsIds = [...new Set(allCmsWithDefault.flatMap(getCmsIds))];

const getTranslation = (cmsWithDefault: CmsObjectWithDefault) =>
    Object.entries(cmsWithDefault).reduce<CmsTranslation>((acc, [, { cmsId, defaultTranslation }]) => {
        acc[cmsId] = defaultTranslation;
        return acc;
    }, {});

export const allDefaultTranslations = Object.assign({}, ...allCmsWithDefault.map(getTranslation));
